import React from 'react';

const LoadingScreen: React.FC = () => {
    return (
        <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-50">
            <div className="w-16 h-16 mb-4">
                <svg
                    className="animate-spin"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#E5E7EB"
                        strokeWidth="4"
                    />
                    <path
                        d="M12 2C6.47715 2 2 6.47715 2 12C2 14.7255 3.09032 17.1962 4.85857 19"
                        stroke="#9D2235"
                        strokeWidth="4"
                        strokeLinecap="round"
                    />
                </svg>
            </div>
            <h1 className="text-2xl font-bold text-brandMaroon">AnswerThis</h1>
            <p className="text-gray-500 mt-2">Loading your research assistant...</p>
        </div>
    );
};

export default LoadingScreen; 